import Index from "../components/CoreValue/index";

const CoreValue = () => {
    return <Index />;
};

export default CoreValue;
